import React from 'react';
import classNames from 'classnames';
import { Tooltip } from '@zvuk-b2b/ui-kit';
import { useDetectTextOverflow } from '@shared/lib/textOverflow';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileHeaderProps } from './types';
import styles from '../index.module.scss';

export const MediafileHeader: React.FC<MediafileHeaderProps> = ({
  id,
  title,
  poster,
  metadata,
  statusMessage,
  state,
  leading,
}) => {
  const { textRef, isOverflow } = useDetectTextOverflow(`[data-testid="${DATA_TEST_IDS.TITLE(id)}"]`);

  return (
    <div
      className={styles.header}
      data-testid={DATA_TEST_IDS.HEADER(id)}>
      {leading && (
        <div
          className={styles.leading}
          data-testid={DATA_TEST_IDS.LEADING(id)}>
          {leading}
        </div>
      )}
      <div
        className={styles.headerBody}
        data-testid={DATA_TEST_IDS.HEADER_BODY(id)}>
        {poster}
        <div
          ref={textRef}
          className={styles.details}>
          <Tooltip
            asChild
            content={title}
            placement="top-start"
            isDisabled={!isOverflow}
            triggerClassName={styles.titleContainer}
            className={styles.titleTooltip}
            sideOffset={10}>
            <span
              className={styles.title}
              data-testid={DATA_TEST_IDS.TITLE(id)}
              // Read-only overflowing text needs focus to expose its full accessible description.
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex={isOverflow ? 0 : undefined}>
              {title}
            </span>
          </Tooltip>
          {metadata != null && (
            <div
              className={styles.metadata}
              data-testid={DATA_TEST_IDS.METADATA(id)}>
              {metadata}
            </div>
          )}
          {statusMessage && (
            <div
              className={classNames(styles.status, state === 'upload-error' && styles.error)}
              data-testid={DATA_TEST_IDS.STATUS(id)}>
              {statusMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
